import { render, staticRenderFns } from "./NewEditOrder.vue?vue&type=template&id=34208291&"
import script from "../../models/app-design/new-edit-order.ts?vue&type=script&lang=ts&"
export * from "../../models/app-design/new-edit-order.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports